import * as React from 'react';

import {ErrorStateSmall} from 'shells/error-state/error-state-small';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {SectionLabel} from 'shells/typography/section-label';

import {useGetSessionUser} from '../core/use-get-session-user';

import {AccountDetailsSection} from './peep-details/account-details/account-details-section';
import {ContactDetailsSection} from './peep-details/contact-details/contact-details-section';

import styles from './peep-details-section.module.css';

type Props = {
    peepApiId: string;
    model: any;
};

export function PeepDetailsSection(props: Props) {
    const {user} = useGetSessionUser();

    const isPeepAccount = props.model.attributes.type === 'accounts';
    const isModelLoading = typeof props.model.attributes.type === 'undefined';

    return (
        <div className={styles['peep-details-section']}>
            {isPeepAccount ? (
                <AccountDetailsSection
                    accountId={props.peepApiId}
                    isModelLoading={isModelLoading}
                    currentUser={user}
                />
            ) : (
                <ContactDetailsSection
                    contactId={props.peepApiId}
                    isModelLoading={isModelLoading}
                    currentUser={user}
                />
            )}
        </div>
    );
}

// Shared label component for both details sections
export const Label = (props: {
    children: React.ReactNode;
    htmlFor: string;
    isDisabled?: boolean;
}): React.ReactElement => (
    <SectionLabel noBottomBorder={true} noBottomMargin={true} as='label' htmlFor={props.htmlFor}>
        {props.isDisabled ? (
            <span className={styles.disabled}>{props.children}</span>
        ) : (
            props.children
        )}
    </SectionLabel>
);

// Shared loading state component for both details sections
export const LoadingState = () => (
    <div className={styles['special-state-container']}>
        <LoadingPage />
    </div>
);

// Shared error state component for both details sections
export const ErrorState = () => (
    <>
        <div className={styles['special-state-overlay']} />
        <div className={styles['special-state-container']}>
            <ErrorStateSmall message='We’re having trouble requesting this information' />
        </div>
    </>
);
